import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Trans, useTranslation } from 'next-i18next';
import { useAuthentication } from '../../../hooks/index.js';
import { ActionLink, LabelSmall } from '../../../primitives/index.js';
import { AUTHENTICATION_QA_ID, qaId } from '../../../utils/qaId.js';
export const LinkToWidget = ({
  type,
  onClick
}) => {
  const {
    t
  } = useTranslation('authentication');
  const {
    toggleWidget
  } = useAuthentication();
  const handleOpenWidget = () => {
    toggleWidget(type);
    if (onClick) {
      onClick();
    }
  };
  return _jsx(LabelSmall, {
    textAlign: "center",
    "data-testid": qaId(AUTHENTICATION_QA_ID, `${type}Widget-link-to`),
    children: _jsx(Trans, {
      i18nKey: t(`linkTo.${type}`),
      components: [_jsx(ActionLink, {
        onClick: handleOpenWidget
      }, type)]
    })
  });
};